import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CityService } from '../../services/city.service';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { Customer, CustomerStatus, Employee, GeoCoordinate, SearchCityState } from '../../models/models';

@Component({
    selector: 'customer-quick-add',
    templateUrl: './customer-quick-add.component.html',
    standalone: false
})
export class CustomerQuickAdd implements OnChanges, OnInit {
    @Input() customerType: string = "";
    @Input() countryCode: string = "US";
    @Input() isCRM: boolean = false;
    @Output() onRefreshCustomer = new EventEmitter<any>();

    public customerID: number = 0;
    public customer: Customer = {} as Customer;
    private leadStatus: CustomerStatus = {} as CustomerStatus;
    public salesReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public accountReps: Employee[] = [];
    //public cityZipList: City[] = [];
    private customerCity: SearchCityState = {} as SearchCityState;
    public timeZoneName: string = "";
    private usPhoneMask: string = "(999) 000-0000";
    private mexicoPhoneMask: string = "99-999-999-9999";
    public phoneFilter: string = "US";
    public phoneMask: string = "(999) 000-0000";

    public customerForm: UntypedFormGroup = new UntypedFormGroup({
        cityStateZipCtrl: new UntypedFormControl(''),
        cityCtrl: new UntypedFormControl('')
    });

    constructor(private azureMapsService: AzureMapsService, private cityService: CityService,
        private crmService: CRMService, private employeeService: EmployeeService,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.getEmployees();
        //this.getCities();
        this.initValues();
        console.log("ngOnInit", this.customer);
    }

    ngOnChanges() {
        console.log("ngOnChanges", this.customer);
    }

    private initValues() {
        if (this.countryCode == "MX") {
            this.phoneMask = this.mexicoPhoneMask;
        }
        else {
            this.phoneMask = this.usPhoneMask;
        }
        this.customer = this.getNewCustomer();
        this.crmService.getCustomerStatuses().subscribe(result => {
            var statuses: CustomerStatus[] = result;
            if (this.customerType.toLowerCase() == "lead") {
                this.leadStatus = statuses.filter(t => t.abbreviation == "Unqualified Lead")[0];
            }
            else {
                this.leadStatus = statuses.filter(t => t.abbreviation == "SW Lead")[0];
            }
            this.customer.customerStatusId = this.leadStatus.customerStatusId;
            //this.customer.customerStatus = this.leadStatus;
        });
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
            this.salesReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            this.opsReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            this.accountReps = result;
        });
    }

    public getCoords() {
        //var city = this.customerForm.controls['cityCtrl'].value as City;
        var city = this.customerCity;
        //if (city.cityId == undefined) {
        //    city = this.customer.city;
        //}
        this.azureMapsService.getGeoCoordinateByAddress(city.countryAbbr.trim(), city.stAbbr.trim(), city.zip, city.name, this.customer.address1).subscribe(result => {
            var coords: GeoCoordinate[] = result.resultCollection;
            if (coords.length > 0) {
                this.customer.latitude = coords[0].latitude;
                this.customer.longitude = coords[0].longitude;
            }
        });
    }

    public citySTChanged(evt: any) {
        var cityID = evt;
        console.log("citySTChanged", cityID, this.customerCity);
        this.cityService.getSearchCityStateByCityID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.customerCity = result.resultCollection[0];
                this.customer.cityId = cityID;
                this.customer.apiZip = this.customerCity.zip;
                this.setTimeZoneName();
                this.getCoords();
                console.log("citySTChanged:customerCity", cityID, this.customerCity, result);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private setTimeZoneName() {
        if (this.customerCity.windowsRegistryTimeZoneName != null) {
            this.timeZoneName = this.customerCity.windowsRegistryTimeZoneName;
        }
        //else if (this.customer.city.epiTimeZone) {
        //    this.timeZoneName = this.customer.city.epiTimeZone.windowsRegistryTimeZoneName;
        //}
        //else if (this.customer.epiTimeZone) {
        //    this.timeZoneName = this.customer.epiTimeZone.windowsRegistryTimeZoneName;
        //}
    }

    public saveCustomer() {
        this.utilService.isLoading = true;
        //var city = this.customerForm.controls['cityCtrl'].value as City;
        var city = this.customerCity;
        if (city != null) {
            //this.customer.city = null;
            this.customer.cityId = city.cityID;
            console.log("saveCustomer", this.customer);
            this.crmService.saveCustomer(this.customer).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.customerID > 0) {
                    //this.getCustomers();
                    this.customer = result;
                    this.customerID = result.customerID;
                    if (this.isCRM) {
                        this.close();
                    }
                } else {
                    this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                }
            });
        }
        else {
            this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
        }
    }

    public close() {
        this.customer = {} as Customer;
        this.onRefreshCustomer.emit(this.customerID);
    }

    public cancelCustomer() {
        this.customer = {} as Customer;
        this.onRefreshCustomer.emit();
    }

    public getNewCustomer() {
        //var newCustomerType = this.customerType;
        //if (this.customerType.indexOf("Dispatch") >= 0) {
        //    newCustomerType = "Dispatcher";
        //}
        //else if (this.customerType.indexOf("Driver") >= 0) {
        //    newCustomerType = "Driver";
        //}
        var newCustomer = {
            customerID: 0,
            name: "",
            //customerCode: "",
            address1: "",
            address2: "",
            cityId: 0,
            opsRepId: 0,
            salesEmployeeID: 0,
            accountRepId: 0,
            customerStatusId: 0,
            apiZip: "",
            createDate: new Date(),
            createEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            //lastRevisedEmployeeId: 0,
            activeInd: true,
            billToInd: this.customerType == "billto" ? true : false,
            consigneeInd: this.customerType == "consignee" ? true : false,
            shipperInd: this.customerType == "shipper" ? true : false,
            retiredInd: false,
            freightSpend: 0,
            parent: "N",
            monthlyNetRevenueBaseLine: 0
            //parentCustomerId: 0,
            //website: "",
            //industryId: 0,
            //commentId: 0
            //city: null
            //customerStatus: {} as CustomerStatus
        } as Customer;
        return newCustomer;
    }
}
